import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BASKET_DEAL_PRODUCT_QUANTITY } from '../../brands/default/content/components/checkout';
import {
  getGiftPackDetails,
  getMaxPurchaseQuantity,
  getSelectValues,
} from '../../helpers/checkout';
import {
  getDealPurchaseCap,
  getProductPurchaseCap,
  isExist,
} from '../../helpers/deals';
import {
  removeProductFromBasket,
  updateProductQuantity,
} from '../../redux/actions/basket';
import { CHECKOUT_STATUS } from '../../redux/reducers/checkout';
import CustomNativeSelect from '../_generic/custom-native-select/CustomNativeSelect';

export default function BasketDealProductQuantity({
  bt,
  giftWrap,
  isAuthenticated,
  deal,
  product,
  flightDeal,
  remainingQuantity,
}) {
  const dispatch = useDispatch();
  const disabled = useSelector(
    (state) =>
      state.checkout.status === CHECKOUT_STATUS.UPDATING ||
      state.checkout.status === CHECKOUT_STATUS.REFRESHING,
  );
  const checkoutData = useSelector((state) => state.checkout.checkoutData);
  let max = getMaxPurchaseQuantity(isAuthenticated, deal, product);
  const totalRemainingForDay = getProductPurchaseCap(deal);

  if (totalRemainingForDay !== null && totalRemainingForDay >= 0) {
    max = getDealPurchaseCap(max, totalRemainingForDay);
  }

  if (
    deal.products.length > 1 &&
    isExist(remainingQuantity) &&
    remainingQuantity === 0
  ) {
    max = getDealPurchaseCap(max, remainingQuantity, product.quantity);
  }

  const values = getSelectValues(1, max);

  const onDelete = () => {
    if (product.gifting.giftPackProductId) {
      const addedGiftPack = getGiftPackDetails(
        checkoutData.deals,
        product.gifting.giftPackProductId,
      );
      dispatch(removeProductFromBasket(bt, product, addedGiftPack, giftWrap));
    }
    dispatch(removeProductFromBasket(bt, product, null, giftWrap));
  };

  const onChange = (event) => {
    dispatch(
      updateProductQuantity(
        bt,
        product,
        event.target.value,
        product.quantity,
        giftWrap,
      ),
    );
  };

  return (
    <>
      <CustomNativeSelect
        ariaLabel={BASKET_DEAL_PRODUCT_QUANTITY.selectQuantity}
        className="quantity__select"
        disabled={flightDeal || disabled}
        onChange={onChange}
        value={product.quantity}
      >
        {values.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </CustomNativeSelect>
      <button
        aria-label={BASKET_DEAL_PRODUCT_QUANTITY.delete}
        className="quantity__delete"
        disabled={disabled}
        onClick={onDelete}
        type="button"
      >
        <FontAwesomeIcon className="quantity__delete-icon" icon={faTrash} />
      </button>
      <style jsx>{`
        .quantity__delete {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background-color: transparent;
          color: #333333;
          border: 1px solid #b3b3b3;
          border-radius: 5px;
          height: 28px;
          width: 28px;
          padding: 0;
        }
        .quantity__delete:disabled {
          border: 1px solid #b3b3b3;
        }
        :global(.quantity__delete:disabled .quantity__delete-icon) {
          opacity: 0.4;
        }
        :global(.quantity__select) {
          margin-right: 8px;
        }
        :global(.quantity__delete-icon) {
          height: 14px;
          width: 14px;
        }
      `}</style>
    </>
  );
}

BasketDealProductQuantity.propTypes = {
  bt: PropTypes.string,
  deal: PropTypes.object,
  flightDeal: PropTypes.bool,
  giftWrap: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  product: PropTypes.object,
  remainingQuantity: PropTypes.number,
};
